/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import {
    Component,
    Inject,
    Input,
} from '@angular/core';

import {
    HealthMonitor,
    HealthMonitorTcp,
} from 'object-types';

import { IHealthMonitorTcp } from 'generated-types';
import { L10nService } from '@vmw/ngx-vip';
import { ITEM_ID_TOKEN } from 'ng/shared/shared.constants';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { HealthMonitorItem } from 'ajs/modules/healthmonitor/factories/health-monitor-item.factory';
import * as globalL10n from 'global-l10n';
import * as l10n from './tcp-health-monitor-config.l10n';
import './tcp-health-monitor-config.component.less';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Health Monitor Config Component for TCP Health Monitor Type.
 *
 * @author Rajawant Prajapati
 */
@Component({
    selector: 'tcp-health-monitor-config',
    templateUrl: './tcp-health-monitor-config.component.html',
})
export class TcpHealthMonitorConfigComponent {
    /**
     * Health Monitor ObjectTypeItem instance.
     */
    @Input()
    public editable: HealthMonitorItem;

    /**
     * True if the TCP Health Monitor Item is being edited, not created.
     */
    public readonly isEditing: boolean;

    /**
     * Object types used in template.
     */
    public readonly objectTypes = {
        HealthMonitor,
        HealthMonitorTcp,
    };

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(
        l10nService: L10nService,
        @Inject(ITEM_ID_TOKEN)
        itemId: string,
    ) {
        l10nService.registerSourceBundles(dictionary);

        this.isEditing = Boolean(itemId);
    }

    /**
     * Getter for TCP Monitor message item.
     */
    public get tcpMonitor(): MessageItem<IHealthMonitorTcp> {
        const { tcpMonitor } = this.editable;

        return tcpMonitor;
    }
}
